export enum SurveyStep {
  Landing = 1,
  AnswerQuestion = 2,
  Resolve = 3,
  PatientInfo = 4,
  PassiveRoute = 5,
  SentConfirmation = 6,
  ScheduleAppointment = 7
}

export interface Question {
  Id: number;
  Question: string;
  LineItems?: string[];
  Answers: Answer[];
  SelectedAnswer: Answer | null;
}

export interface Answer {
  Answer: string;
  IsAberrant: boolean;
  NextQuestion?: number;
  Resolve?: string;
}
